(() => {
  const roots = new WeakSet();
  const videos = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pauseAutomatic = (video, state) => {
    if (!video.paused) {
      state.automaticPause = true;
      video.pause();
    }
  };
  const attemptPlay = (video, state) => {
    if (!state.visible || state.userPaused || video.ended || document.hidden || reduced.matches) return;
    const promise = video.play();
    if (promise) promise.catch(() => { video.dataset.llcPlayback = 'manual'; });
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      const state = videos.get(video);
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
      if (state.visible) attemptPlay(video, state);
      else pauseAutomatic(video, state);
    });
  }, {threshold:[0,0.2]});
  const setup = video => {
    if (video.parentElement?.matches('.instant-video-fill__wrapper')) {
      const posterLayer = video.parentElement.querySelector('img.instant-video-fill__video');
      if (posterLayer) {
        if (!video.poster) video.poster = posterLayer.currentSrc || posterLayer.src;
        posterLayer.hidden = true;
        posterLayer.setAttribute('aria-hidden', 'true');
        posterLayer.style.setProperty('display', 'none', 'important');
      }
    }
    if (videos.has(video)) return;
    const state = {visible:false,userPaused:false,automaticPause:false};
    videos.set(video, state);
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = true;
    video.autoplay = false;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('controls', '');
    video.setAttribute('preload', 'metadata');
    video.dataset.llcAutoplay = 'visible-muted';
    if (!video.getAttribute('aria-label')) video.setAttribute('aria-label', 'Film van het Longevity Lifestyle Center');
    const overlay = video.parentElement.querySelector('button[onclick*=".play()"]');
    if (overlay) {
      overlay.hidden = true;
      overlay.style.setProperty('display', 'none', 'important');
    }
    video.addEventListener('play', () => {
      state.userPaused = false;
      video.dataset.llcPlayback = 'starting';
    });
    video.addEventListener('playing', () => {
      video.dataset.llcPlayback = 'playing';
    });
    video.addEventListener('pause', () => {
      if (state.automaticPause) state.automaticPause = false;
      else if (!video.ended) state.userPaused = true;
      video.dataset.llcPlayback = 'paused';
    });
    video.addEventListener('error', () => { video.dataset.llcPlayback = 'error'; });
    video.addEventListener('loadeddata', () => attemptPlay(video, state), {once:true});
    if (reduced.matches) pauseAutomatic(video, state);
    observer.observe(video);
  };
  const scan = root => {
    root.querySelectorAll('video').forEach(setup);
    root.querySelectorAll('instant-layout').forEach(host => {
      if (host.shadowRoot) scan(host.shadowRoot);
    });
    if (roots.has(root)) return;
    roots.add(root);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => mutation.addedNodes.length)) scan(root);
    }).observe(root, {childList:true,subtree:true});
  };
  const start = () => scan(document.querySelector('main') || document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  window.addEventListener('load', start, {once:true});
  customElements.whenDefined('instant-layout').then(start);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('visibilitychange', () => videos.forEach((state, video) => {
    if (document.hidden) pauseAutomatic(video, state);
    else attemptPlay(video, state);
  }));
  reduced.addEventListener('change', () => videos.forEach((state, video) => {
    if (reduced.matches) pauseAutomatic(video, state);
    else attemptPlay(video, state);
  }));
})();
